import { LevelIcon } from "../../ui/counts.tsx";
import { Segmented } from "../../ui/Segmented.tsx";
import { SEVERITIES } from "../../ui/styles.ts";

type Level = (typeof SEVERITIES)[number];

/**
 * Picking open issues of at least a level, each segment showing every level it takes in, widening: errors; warnings
 * and errors; any (named in its tooltip, by `name`). With `all`, a last one wider still (with or without issues),
 * chosen as `""`.
 */
export function LevelFilter(p: {
  label: string;
  value: Level | "";
  onPick: (v: Level | "") => void;
  name: (level: Level) => string;
  all?: { label: string; title: string };
}) {
  return (
    <Segmented
      size="md"
      label={p.label}
      value={p.value}
      onValue={p.onPick}
      options={[
        ...SEVERITIES.map((s) => ({
          value: s,
          label: <span class="sr-only">{p.name(s)}</span>,
          icon: <LevelIcons level={s} size={16} />,
          title: p.name(s),
        })),
        ...(p.all ? [{ value: "" as const, label: p.all.label, title: p.all.title }] : []),
      ]}
    />
  );
}

/** Every level that open issues of at least `level` take in, in their colours: errors; warnings and errors; all. */
export function LevelIcons(p: { level: Level; size: number }) {
  return (
    <span class="inline-flex items-center gap-0.5">
      {SEVERITIES.slice(0, SEVERITIES.indexOf(p.level) + 1)
        .reverse()
        .map((l) => (
          <LevelIcon key={l} level={l} size={p.size} />
        ))}
    </span>
  );
}
